import { render, staticRenderFns } from "./AwesomeMobile.vue?vue&type=template&id=204d7d17&scoped=true&"
import script from "./AwesomeMobile.vue?vue&type=script&lang=js&"
export * from "./AwesomeMobile.vue?vue&type=script&lang=js&"
import style0 from "./AwesomeMobile.vue?vue&type=style&index=0&id=204d7d17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d7d17",
  null
  
)

export default component.exports